import React, { useEffect } from 'react';
import './Menu.css';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveMenuItem } from '../../store/menuSlice.js';
import { clearTokens } from '../../store/tokensSlice.js';
import MenuButton from './menuButton.jsx';
import { Calculator as CalculatorIcon, CircleDot as RadiiIcon } from 'lucide-react';
import { ReactComponent as Logout } from '../icons/logout.svg';
import { ReactComponent as Settings } from '../icons/settings.svg';
import { ReactComponent as UserSquare } from '../icons/user-square.svg';
import { useLocation } from 'react-router-dom';

const menuItems = [
  {
    path: '/',
    icon: CalculatorIcon,
    label: 'Objętość',
    text: 'Objętość',
  },
  {
    path: '/radii',
    icon: RadiiIcon,
    label: 'Promienie R1/R2',
    text: 'Promienie R1/R2',
  },
];

function Menu() {
  const location = useLocation();
  const activeLink = useSelector((state) => state.menu.activeMenuItem);
  const dispatch = useDispatch();

  const handleLinkClick = (path) => {
    dispatch(setActiveMenuItem(path));
  };

  useEffect(() => {
    dispatch(setActiveMenuItem(location.pathname));
  }, [location.pathname, dispatch]);

  const handleLogoutClick = () => {
    dispatch(clearTokens());
    window.location.reload();
  };

  return (
    <div className="menu">
      <div className="menu-content">
        <div className="menu-center">
          {menuItems.map((item) => (
            <MenuButton
              key={item.path}
              path={item.path}
              currentPath={activeLink}
              onClick={handleLinkClick}
              icon={item.icon}
              label={item.label}
              buttonText={undefined}
              showLabel={true}
              showSpeechBubble={true}
            />
          ))}
        </div>

        <div className="menu-right">
          <MenuButton
            path="/settings"
            currentPath={activeLink}
            onClick={handleLinkClick}
            icon={Settings}
            label="Ustawienia"
            afterClickingChange={false}
          />
          <MenuButton
            path="/profile"
            currentPath={activeLink}
            onClick={handleLinkClick}
            icon={UserSquare}
            label="Profil"
            afterClickingChange={false}
          />
          <span className="menu-divider" aria-hidden="true"></span>
          <MenuButton
            path="/logout"
            currentPath={activeLink}
            onClick={handleLogoutClick}
            icon={Logout}
            label="Wyloguj się"
            iconfirst={false}
            afterClickingChange={false}
          />
        </div>
      </div>
    </div>
  );
}

export default Menu;
